export const configs = {
    REACT_APP_API_URL:"https://pwa-cm-be.ita.belka-games.com/",
    REACT_APP_ENV:"dev",
    REACT_APP_VERSION_URL:"https://cm-staging-webgl.belka-games.com/static/mcmu-standalone-dev",
    PUBLIC_URL:"/play",
    REACT_APP_CLIENT_PROD_URL:"https://mcmustatic.b-cdn.net/mcmu-standalone-prod/Build-",
    REACT_APP_CLIENT_DEV_URL:"https://cm-staging-webgl.belka-games.com/static/mcmu-standalone-dev/Build-",
    REACT_APP_CLIENT_PROD_CHEATS_URL:"https://mcmustatic.b-cdn.net/mcmu-standalone-prod-cheats/Build-",
    REACT_APP_DOMAIN:"https://pwa-cm-fe.ita.belka-games.com/",
    // Период тестирования: в шапке две кнопки входа — Firebase (новая) и Xsolla (старая). Выключить при отказе от Xsolla.
    DUAL_AUTH_TEST: false,
    FIREBASE: {
        apiKey: "AIzaSyA4SwWpW-GwUltuhZQeIYSMk1nsN2wy9Pk",
        authDomain: "pwa-cm-fe.stage.belka-games.com",
        projectId: "cm-test-853b4",
        storageBucket: "cm-test-853b4.appspot.com",
        messagingSenderId: "1064677070576",
        appId: "1:1064677070576:web:29c6c1ebff53a123769435",
        measurementId: "G-G0TD9K6JK7"
    }
}
